import { AgGridColumnProps } from "ag-grid-react";
import { asTimelessDateUTC } from "lqx-react/src";
import { getAssetErrors, getAssetStatus, getCellColor } from "../components/assets-table";
import { CustomHeaderCheckbox } from "./custom-header-checkbox";

export enum FilterName {
    InvoiceNumber = 'invoiceNumbers',
    FaceValue = 'faceValues',
    InvoiceDate = 'invoiceDates',
    InvoiceDueDate = 'invoiceDueDates',
    Currency = 'currencies',
    Supplier = 'suppliers',
    Buyer = 'buyers',
    AnticipatedPaymentDate = 'anticipatedPaymentDates',
    AnticipatedSettlementDate = 'anticipatedSettlementDates',
    EffectiveDate = 'effectiveDates',
    AdjustmentAmount = 'adjustmentAmounts',
    OutstandingAmountSeller = 'outstandingAmountSellers',
    AdjustedFaceValue = 'adjustedFaceValues',
    PurchaseOrderNumber = 'purchaseOrderNumbers',
    RelationshipReferenceNumber = 'relationshipReferenceNumbers',
    FundingDate = 'fundingDates',
    // BuyerDuns = 'buyerDunses',
    // InsuredPartyBuyerReferenceNumber = 'insuredPartyBuyerReferenceNumbers',
    // InsureCarrierBuyerReferenceNumber = 'insuredCarrierBuyerReferenceNumber'
}


export enum FilterTypeInvoices {
    All = 0,
    ValidationCategory,
    AssetState,
    InvoiceNumber,
    FaceValue,
    InvoiceDate,
    InvoiceDueDate,
    Currency,
    Supplier,
    Buyer,
    AnticipatedPaymentDate,
    AnticipatedSettlementDate,
    EffectiveDate,
    AdjustmentAmount,
    OutstandingAmountSeller,
    AdjustedFaceValue,
    PurchaseOrderNumber,
    RelationshipReferenceNumber,
    FundingDate,
    // BuyerDuns,
    // InsuredPartyBuyerReferenceNumber,
    // InsuredCarrierBuyerReferenceNumber
}

export enum InvoicesSortingBase {
    Id = 0,
    CreatedOn,
    UpdatedOn,
    ValidationCategory,
    AssetState,
    InvoiceNumber,
    FaceValue,
    InvoiceDate,
    InvoiceDueDate,
    Currency,
    Supplier,
    Buyer,
    AnticipatedPaymentDate,
    AnticipatedSettlementDate,
    EffectiveDate,
    AdjustmentAmount,
    OutstandingAmountSeller,
    AdjustedFaceValue,
    PurchaseOrderNumber,
    RelationshipReferenceNumber,
    FundingDate,
    // BuyerDuns,
    // InsuredPartyBuyerReferenceNumber,
    // InsuredCarrierBuyerReferenceNumber
}

export enum InvoicesTableColumns {
    Status = 0,
    InvoiceNumber,
    FaceValue,
    InvoiceDate,
    InvoiceDueDate,
    Currency,
    Supplier,
    Buyer,
    AnticipatedPaymentDate,
    AnticipatedSettlementDate,
    EffectiveDate,
    AdjustmentAmount,
    OutstandingAmountSeller,
    AdjustedFaceValue,
    PurchaseOrderNumber,
    RelationshipReferenceNumber,
    FundingDate,
    // BuyerDuns,
    // InsuredPartyBuyerReferenceNumber,
    // InsuredCarrierBuyerReferenceNumber,
    Errors
}

export const InvoiceTableColumns: AgGridColumnProps[] = [
    {
        colId: 'CheckBox',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true
    },
    {
        colId: InvoicesTableColumns.Status.toString(),
        headerName: "Status",
        filter: 'agSetColumnFilter',
        filterParams: {
            values: ['Pass Validation - New', 'Pass Validation - Modified', 'Require Review', 'Duplicated', 'Conflict', 'Saved for Later', 'Digitized', 'Modifies Existing']
        },
        valueGetter: params => getAssetStatus(params.data),
        cellStyle: params => { return { color: getCellColor(params.data) } },
        sortable: true
    },
    {
        colId: InvoicesTableColumns.Errors.toString(),
        headerName: "Errors",
        valueGetter: params => getAssetErrors(params.data)
    },
    {
        colId: InvoicesTableColumns.InvoiceNumber.toString(),
        headerName: "Invoice Number",
        field: "number",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: InvoicesTableColumns.FaceValue.toString(),
        headerName: "Face Value",
        field: 'faceValue',
        cellStyle: { textAlign: "right" },
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        //valueFormatter: asCurrency,
        sortable: true
    },
    {
        colId: InvoicesTableColumns.InvoiceDate.toString(),
        headerName: "Invoice Date",
        field: 'invoiceDate',
        valueFormatter: asTimelessDateUTC,
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: InvoicesTableColumns.InvoiceDueDate.toString(),
        headerName: "Invoice Due Date",
        field: 'invoiceDueDate',
        valueFormatter: asTimelessDateUTC,
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: InvoicesTableColumns.Currency.toString(),
        headerName: "Currency",
        field: "currency",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: InvoicesTableColumns.Supplier.toString(),
        headerName: "Supplier",
        field: "supplier.name",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: InvoicesTableColumns.Buyer.toString(),
        headerName: "Buyer",
        field: "buyer.name",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: InvoicesTableColumns.AnticipatedPaymentDate.toString(),
        headerName: "Anticipated Payment Date",
        field: 'anticipatedPaymentDate',
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        valueFormatter: asTimelessDateUTC,
        sortable: true
    },
    {
        colId: InvoicesTableColumns.AnticipatedSettlementDate.toString(),
        headerName: "Anticipated Settlement Date",
        field: 'anticipatedSettlementDate',
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        valueFormatter: asTimelessDateUTC,
        sortable: true
    },
    {
        colId: InvoicesTableColumns.EffectiveDate.toString(),
        headerName: "Effective Date",
        field: 'effectiveDate',
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        valueFormatter: asTimelessDateUTC,
        sortable: true
    },
    {
        colId: InvoicesTableColumns.AdjustmentAmount.toString(),
        headerName: "Adjustment Amount",
        field: 'adjustmentAmount',
        cellStyle: { textAlign: "right" },
        //valueFormatter: asCurrency,
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: InvoicesTableColumns.OutstandingAmountSeller.toString(),
        headerName: "Outstanding Amount Seller",
        field: 'outstandingAmountSeller',
        cellStyle: { textAlign: "right" },
        //valueFormatter: asCurrency,
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: InvoicesTableColumns.AdjustedFaceValue.toString(),
        headerName: "Adjusted Face Value",
        field: 'adjustedFaceValue',
        cellStyle: { textAlign: "right" },
        //valueFormatter: asCurrency,
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: InvoicesTableColumns.PurchaseOrderNumber.toString(),
        headerName: "Purchase Order Number",
        field: "purchaseOrder.number",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: InvoicesTableColumns.RelationshipReferenceNumber.toString(),
        headerName: "Relationship Reference Number",
        field: "relationshipIdentifier",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: InvoicesTableColumns.FundingDate.toString(),
        headerName: "Funding Date",
        field: 'fundingDate',
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        valueFormatter: asTimelessDateUTC,
        sortable: true
    },
    // {
    //     colId: InvoicesTableColumns.BuyerDuns.toString(),
    //     headerName: "Buyer DUNS",
    //     field: "buyer.duns",
    //     filter: 'agTextColumnFilter',
    //     filterParams: {
    //         filterOptions: ['contains'],
    //         suppressAndOrCondition: true
    //     },
    //     sortable: true
    // }, 
    // {
    //     colId: InvoicesTableColumns.InsuredPartyBuyerReferenceNumber.toString(),
    //     headerName: "Insured Party Buyer Reference Number",
    //     valueGetter: cell =>{
    //         const invoiceChange = cell.data as InvoiceChange;
    //         if(invoiceChange.buyer.customIdentifiers.length <= 0) return '';
    //         return invoiceChange.buyer.customIdentifiers[0].value;
    //     },
    //     filter: 'agTextColumnFilter',
    //     filterParams: {
    //         filterOptions: ['contains'],
    //         suppressAndOrCondition: true
    //     },
    //     sortable: true
    // }, 
    // {
    //     colId: InvoicesTableColumns.InsuredCarrierBuyerReferenceNumber.toString(),
    //     headerName: "Insured Carrier Buyer Reference Number",
    //     valueGetter: cell =>{
    //         const invoiceChange = cell.data as InvoiceChange;
    //         if(invoiceChange.buyer.customIdentifiers.length <= 1) return '';
    //         return invoiceChange.buyer.customIdentifiers[1].value;
    //     },
    //     filter: 'agTextColumnFilter',
    //     filterParams: {
    //         filterOptions: ['contains'],
    //         suppressAndOrCondition: true
    //     },
    //     sortable: true
    // }
]
